import { useQuery } from '@tanstack/react-query'

import { tenMinutes } from '../../../constants/constants'
import { apiBase } from '../../../utils/base-url'
import { useFetch } from '../../../utils/fetch-request'
import { ReportI } from './use-power-bi-reports-by-type'

export interface ReportWithToken extends ReportI {
  token: string
}

export function usePowerBiReportWithToken(reportId: string | undefined) {
  const fetchReportTokenRequest = useFetch<ReportWithToken>()
  return useQuery({
    queryKey: ['/reports?reportId', reportId],
    queryFn: () =>
      fetchReportTokenRequest(
        `${apiBase()}/reports?reportId=${reportId}&includeEmbedToken=true`,
      ),
    staleTime: tenMinutes,
    enabled: !!reportId,
  })
}
